import { createAsyncThunk } from '@reduxjs/toolkit';

import * as listenerHistory from 'endpoints/roomHistory/set-listener-data';
import { ApiResponse } from 'endpoints/endpoint';
import { apiRequest } from 'client/utils';

export const setListenerHistory = createAsyncThunk<
  ApiResponse<listenerHistory.SetResult, listenerHistory.SetError>,
  listenerHistory.SetParams,
  { rejectValue: string }
>('room/setListenerHistory', async (data, thunkApi) => {
  try {
    const response = await apiRequest<listenerHistory.SetParams, listenerHistory.SetResult, listenerHistory.SetError>(
      listenerHistory.setListenerData,
      { retries: true, data },
    )();

    if (response.success) {
      return response;
    }

    throw new Error('Set listener history error');
  } catch (e) {
    return thunkApi.rejectWithValue((e as Error).message);
  }
});
